import Icons, { SvgIconProps } from '../Icons';

export default function (props: SvgIconProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M4 20.775V3.22498L5.275 4.19998L6.625 3.22498L7.95 4.19998L9.3 3.22498L10.65 4.19998L12 3.22498L13.35 4.19998L14.7 3.22498L16.05 4.19998L17.375 3.22498L18.725 4.19998L20 3.22498V20.775L18.725 19.8L17.375 20.775L16.05 19.8L14.7 20.775L13.35 19.8L12 20.775L10.65 19.8L9.3 20.775L7.95 19.8L6.625 20.775L5.275 19.8L4 20.775ZM6.5 15.875H17.5V14.875H6.5V15.875ZM6.5 12.5H17.5V11.5H6.5V12.5ZM6.5 9.12498H17.5V8.12498H6.5V9.12498ZM5 19.1H19V4.89998H5V19.1Z" />
      </svg>
    </Icons>
  );
}
